import { useState, useEffect } from "react";
import { EMPLOYEE_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import useHasPermission from "src/utils/hooks/security/useHasPermission";
import { employeeEmployeeGroupPermissionRead } from "src/utils/RoleBasedSecurity/permissions";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";

export default function useDepartments(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false,
  noFetching = false
) {
  const [data, setData] = useState([]);

  const hasPermission = useHasPermission(employeeEmployeeGroupPermissionRead);
  const skipAction = !hasPermission || noFetching;

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        skipAction,
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: EMPLOYEE_MANAGEMENT_SERVICE,
          path: "/departments",
          method: "GET",
          mockData,
          additionalParams: {
            "order[name]": "asc",
          },
        },
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, skipAction, setData]);

  return data;
}

export const IRI_PREFIX = "/api/employee-management/v1/rest/departments";

export const mockData = [
  {
    id: "3ba186d2-b0af-430b-936d-9474acdef9cb",
    name: "Dział 1",
    companyId: "279c5217-0229-4f59-b876-519db0d989bb",
    description: "Dział 1 Opis",
    employeeIds: [
      "/api/employee-management/v1/rest/employees/480d3c1a-bbb6-4bcc-b852-fd83fbdd38a4",
    ],
  },
  {
    id: "3ba186d2-b0af-430b-936d-9474acdef9cd",
    name: "Dział 2",
    companyId: "279c5217-0229-4f59-b876-519db0d989bb",
    description: "Dział 2 Opis",
    employeeIds: [],
  },
];
